module.exports = __webpack_public_path__ + "img/whatsapp.b16f44db.png";